import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TM_IMAGE from '../../../assets/works/tm.png';
import TE_IMAGE from '../../../assets/works/te.png';
import MA_IMAGE from '../../../assets/works/mindamigo.png';
import MS_IMAGE from '../../../assets/works/matchstixx.png';
import TS_IMAGE from '../../../assets/works/timesheet.png';
import MAYA_IMAGE from '../../../assets/works/maya.png';
import ProjectStack from '../../components/project/stack';
import { nanoid } from 'nanoid'
import { Position } from '../../model/project-stack-props';
import WorkProps from '../../model/work-props';

const workList = [TM_IMAGE, TE_IMAGE, MA_IMAGE, MS_IMAGE, TS_IMAGE, MAYA_IMAGE];

export default function Works(props: WorkProps){
    return (
        <Container sx={{ marginTop: !props.isMobile ? '8em' : '0', paddingTop: !props.isMobile ? 0 : '4em', paddingBottom: !props.isMobile ? 0 : '4em'}} >
            <Typography component='h2' variant='h6' color='#fff' fontWeight='medium'>
                Works
            </Typography>
            <Typography component='h2' variant='body2' color='#fff' fontWeight='regular' sx={{ marginBottom: 4 }}>
                Ideal approach for a digital engagement
            </Typography>

            {
                workList.map((path,index)=>{
                    return (
                        <ProjectStack
                            isMobile={!props.isMobile ? false : true}
                            key={nanoid()}
                            path={path}
                            position={index % 2 === 0 ? Position.RIGHT : Position.LEFT}
                            alt={`work-${index}`}
                            isStart={index === 0} 
                        />
                    )
                })
            }
        </Container>
    )
}